export default __webpack_public_path__ + "static/lsa-website-1-mobile-781eab0e36324c7c3fd231468f1f3e7b.jpg";